var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-teacher-level" }, [
    _c(
      "div",
      {
        staticClass: "pr",
        class: { "yxtbiz-teacher-level-iserror": _vm.error },
      },
      [
        _c(
          "yxt-select",
          {
            style: _vm.style,
            attrs: {
              multiple: _vm.multiple,
              placeholder: _vm.$t("pc_biz_te_lbl_level" /*级别*/),
              clearable: "",
              "fixed-left-padding": 40,
              "popper-class": "yxtbiz-teacher-level-select",
              size: _vm.size,
            },
            on: { change: _vm.change, blur: _vm.blur },
            model: {
              value: _vm.valueIds,
              callback: function ($$v) {
                _vm.valueIds = $$v
              },
              expression: "valueIds",
            },
          },
          [
            _vm._l(_vm.optionsData, function (item) {
              return _c("yxt-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            _vm.optionsData.length
              ? _c(
                  "div",
                  {
                    staticClass: "pl12 pt15 standard-size-12 color-gray-7",
                    attrs: { slot: "fixed-left" },
                    slot: "fixed-left",
                  },
                  [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("pc_biz_te_lbl_lowLevel" /* 低 */))),
                    ]),
                    _c("yxt-svg", {
                      attrs: {
                        "remote-url": _vm.PcSvgUrl,
                        width: "14px",
                        height:
                          _vm.optionsData.length > 4
                            ? "142px"
                            : _vm.optionsData.length === 4
                            ? "96px"
                            : "62px",
                        "icon-class":
                          _vm.optionsData.length > 4
                            ? "level-noedit"
                            : _vm.optionsData.length === 4
                            ? "level-noedit4"
                            : "level-noedit3",
                      },
                    }),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_te_lbl_heightLevel" /* 高 */))
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
        _vm.error
          ? _c("div", { staticClass: "yxtbiz-teacher-level_errorText" }, [
              _vm._v(_vm._s(_vm.errorText)),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }